(function () {
  // Rewritten from the original scraped bundle to drop its jQuery
  // dependency ($(this), .data(), .find(), .each()) -- this theme never
  // actually loads jQuery anywhere, so every call into it threw
  // "$ is not defined" and silently aborted before either Swiper instance
  // ever initialized. That's why the left image panel never showed
  // anything and the right product carousel never auto-advanced or synced
  // with it. Swiper itself doesn't need jQuery at all, so this is a
  // straight port to native DOM APIs with identical behavior (minus the
  // custom cursor-follow and IntersectionObserver bits, which aren't wired
  // into this theme's markup).
  const splitScreenSlid = () => {
    document.querySelectorAll(".product-slider__section").forEach((wrapper) => {
      if (wrapper.classList.contains("slider_started")) return;
      wrapper.classList.add("slider_started");

      const id = wrapper.id;
      const box = wrapper.querySelector(".product-slider");
      if (!id || !box) return;

      const autoplay = box.dataset.autoplay === "true";
      const stopAutoplay = box.dataset.stopAutoplay === "true";
      const delay = parseFloat(box.dataset.delay) * 1000;
      const speed = parseFloat(box.dataset.speed) * 1000;

      const autoplayParams = autoplay
        ? { autoplay: { delay, disableOnInteraction: false } }
        : {};

      const swiperParams = {
        effect: box.dataset.effect,
        speed,
        keyboard: true,
        mousewheel: { enabled: true, forceToAxis: true, sensitivity: 0.8, thresholdDelta: 20 },
        creativeEffect: {
          prev: { shadow: false, translate: [0, 0, -400] },
          next: { translate: ["100%", 0, 0] },
        },
        coverflowEffect: { rotate: 50, stretch: 0, depth: 100, modifier: 1, slideShadows: false },
        flipEffect: { slideShadows: false },
        ...autoplayParams,
      };

      const swiperImg = new Swiper(`#${id} .product-slider__image-swiper`, {
        navigation: {
          nextEl: `#${id} .product-button-next`,
          prevEl: `#${id} .product-button-prev`,
        },
        ...swiperParams,
        autoplay: false,
      });

      const swiperText = new Swiper(`#${id} .product-slider__product-swiper`, {
        pagination: { el: `#${id} .swiper-pagination`, clickable: true },
        ...swiperParams,
        spaceBetween: 24,
      });

      // Mutually link the two swipers -- clicking/dragging or auto-advancing
      // either one moves the other in lockstep, which is what makes the
      // left image + caption follow whichever product is active on the
      // right.
      swiperImg.controller.control = swiperText;
      swiperText.controller.control = swiperImg;

      if (autoplay && stopAutoplay) {
        const el = document.querySelector(`#${id} .product-slider__wrapper`);
        if (el) {
          el.addEventListener("mouseenter", function () {
            swiperText.autoplay.stop();
          });
          el.addEventListener("mouseleave", function () {
            swiperText.autoplay.start();
          });
        }
      }

      // Custom "Previous" / "Next" cursor label: hovering the left or right
      // half of the product-card panel reveals the corresponding word next
      // to the mouse pointer (native cursor hidden via CSS "cursor:none"
      // over those zones) -- ported from the original bundle's onCursor
      // logic, ".animate()" swapped for a plain style.transform write.
      const onCursor = box.dataset.cursor === "cursor";
      const cursorEl = document.getElementById("cursor");
      const cursorContainer = wrapper.querySelector(".product-slider-cursor");
      if (onCursor && cursorEl && cursorContainer) {
        const icon = cursorContainer.querySelector("#cursor-icon");

        const getCursorClass = (type) => {
          const prevDisabled = box.querySelector(".swiper-button-prev.swiper-button-disabled");
          const nextDisabled = box.querySelector(".swiper-button-next.swiper-button-disabled");
          const prevText = prevDisabled ? "prev prev-disabled" : "prev";
          const nextText = nextDisabled ? "next next-disabled" : "next";
          if (type === "next") return `${nextText} button button--simple`;
          if (type === "prev") return `${prevText} button button--simple`;
          return "button button--simple";
        };

        cursorContainer.addEventListener("mousemove", (e) => {
          const interactable = e.target.closest(".product-slider__buttons");
          const interacting = interactable !== null;
          if (interacting) {
            const x = e.clientX - cursorEl.offsetWidth / 2;
            const y = e.clientY - cursorEl.offsetHeight / 2;
            cursorEl.style.transform = `translate(${x}px, ${y}px)`;
          }
          cursorEl.dataset.type = interacting ? interactable.dataset.type : "";
          if (interacting && icon) icon.className = getCursorClass(interactable.dataset.type);
        });

        cursorContainer.addEventListener("mouseleave", () => {
          cursorEl.dataset.type = "";
        });
      }
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    splitScreenSlid();
    document.addEventListener("shopify:section:load", function () {
      splitScreenSlid();
    });
  });
})();
